import React from 'react';
import { Box, Divider, Heading, Body } from '@hover/blueprint';
import { CAREERS_OUR_VALUES } from '../../../constants';

interface Props {
  selectTab: (title: string) => void;
  description: string;
  currentTab: string;
}

const OurValuesMobile: React.FC<Props> = ({
  selectTab,
  description,
  currentTab,
}) => (
  <Box
    flexDir="column"
    alignItems="center"
    d={{ base: 'flex', tablet: 'none' }}
    pb={800}
  >
    <Heading size={500} isLight marginBottom={500}>
      Our Values
    </Heading>
    <Divider
      my={0}
      borderColor="brandNavy.300"
      borderWidth="1px"
      borderTopWidth={0}
    />
    {CAREERS_OUR_VALUES.map(value => (
      <Box flexDir="column" w="100%">
        <Heading
          onClick={() => selectTab(value.title)}
          mt={500}
          size={800}
          color={currentTab === value.title ? 'brandNavy.500' : 'neutral.0'}
          marginBottom={500}
        >
          {value.title}
        </Heading>
        {currentTab === value.title ? (
          <Body size={500} mb={500}>
            {description}
          </Body>
        ) : null}
        <Divider
          borderWidth="1px"
          borderTopWidth={0}
          my={0}
          borderColor="brandNavy.300"
        />
      </Box>
    ))}
  </Box>
);

export default OurValuesMobile;
